import { Routes } from '@angular/router';
import { RouteEntity } from '@core/router/route.entity';
import { ROUTE_TRANSLATE_KEYS } from '@core/router/route.translate-keys';
import { needShiftGuard } from '@shared/guards/need-shift-guard';
import { authGuard } from './features/auth/guards/auth-guard';

export const routes: Routes = [
    {
        path: RouteEntity.Empty,
        loadComponent: () => import('@shared/components/layout/layout/layout').then((c) => c.Layout),
        children: [
            {
                path: RouteEntity.Empty,
                redirectTo: RouteEntity.Main,
                pathMatch: 'full',
            },
            {
                path: RouteEntity.Main,
                loadComponent: () => import('./features/main/main').then((c) => c.Main),
                data: {
                    title: ROUTE_TRANSLATE_KEYS[RouteEntity.Main],
                },
                canActivate: [authGuard, needShiftGuard],
            },
            {
                path: RouteEntity.SellProduct,
                loadComponent: () => import('./features/sell-product/sell-product').then((c) => c.SellProduct),
                data: {
                    title: ROUTE_TRANSLATE_KEYS[RouteEntity.SellProduct],
                },
                canActivate: [authGuard, needShiftGuard],
            },
            {
                path: RouteEntity.SellCard,
                loadComponent: () => import('./features/add-card/add-card').then((c) => c.AddCard),
                data: {
                    title: ROUTE_TRANSLATE_KEYS[RouteEntity.SellCard],
                },
                canActivate: [authGuard, needShiftGuard],
            },
            {
                path: RouteEntity.RegistryCard,
                loadComponent: () => import('./features/register-card/register-card').then((c) => c.RegisterCard),
                data: {
                    title: ROUTE_TRANSLATE_KEYS[RouteEntity.RegistryCard],
                },
                canActivate: [authGuard, needShiftGuard],
            },
            {
                path: RouteEntity.PrintedTicket,
                loadComponent: () => import('./features/printed-ticket/printed-ticket').then((c) => c.PrintedTicket),
                data: {
                    title: ROUTE_TRANSLATE_KEYS[RouteEntity.PrintedTicket],
                },
                canActivate: [authGuard, needShiftGuard],
            },
            {
                path: RouteEntity.TopUp,
                loadComponent: () => import('./features/top-up/top-up').then((c) => c.TopUp),
                data: {
                    title: ROUTE_TRANSLATE_KEYS[RouteEntity.TopUp],
                },
                canActivate: [authGuard, needShiftGuard],
            },
            {
                path: RouteEntity.LogOut,
                loadComponent: () => import('./features/auth/components/logout/logout').then((c) => c.Logout),
                data: {
                    title: ROUTE_TRANSLATE_KEYS[RouteEntity.LogOut],
                },
                canActivate: [authGuard, needShiftGuard],
            },
            {
                path: RouteEntity.SearchClient,
                loadComponent: () => import('./features/client-search/client-search').then((c) => c.ClientSearch),
                data: {
                    title: ROUTE_TRANSLATE_KEYS[RouteEntity.SearchClient],
                },
                canActivate: [authGuard, needShiftGuard],
            },
        ],
    },
    {
        path: RouteEntity.PrintedForm,
        loadComponent: () => import('./features/printed-form/printed-form').then((c) => c.PrintedForm),
        data: {
            title: ROUTE_TRANSLATE_KEYS[RouteEntity.PrintedForm],
        },
        canActivate: [authGuard],
        children: [
            {
                path: RouteEntity.PrintedTicket,
                loadComponent: () =>
                    import('./features/printed-form/printed-ticket-output/printed-ticket-output').then(
                        (c) => c.PrintedTicketOutput,
                    ),
                canActivate: [authGuard, needShiftGuard],
            },
            {
                path: RouteEntity.TopUp,
                loadComponent: () =>
                    import('./features/printed-form/top-up-output/top-up-output').then((c) => c.TopUpOutput),
                canActivate: [authGuard, needShiftGuard],
            },
            {
                path: RouteEntity.SellProduct,
                loadComponent: () =>
                    import('./features/printed-form/sell-product-output/sell-product-output').then(
                        (c) => c.SellProductOutput,
                    ),
                canActivate: [authGuard, needShiftGuard],
            },
            {
                path: RouteEntity.RegistryCard,
                loadComponent: () =>
                    import('./features/printed-form/register-card-output/register-card-output').then(
                        (c) => c.RegisterCardOutput,
                    ),
                canActivate: [authGuard, needShiftGuard],
            },
            {
                path: RouteEntity.SellCard,
                loadComponent: () =>
                    import('./features/printed-form/sell-card-output/sell-card-output').then((c) => c.SellCardOutput),
                canActivate: [authGuard, needShiftGuard],
            },
        ],
    },
    {
        path: RouteEntity.Shift,
        loadComponent: () => import('./features/shift/shift').then((c) => c.Shift),
        data: {
            title: ROUTE_TRANSLATE_KEYS[RouteEntity.Shift],
        },
        canActivate: [authGuard],
    },
    {
        path: RouteEntity.SignIn,
        loadComponent: () => import('./features/auth/components/login/login').then((c) => c.Login),
        data: {
            title: ROUTE_TRANSLATE_KEYS[RouteEntity.SignIn],
        },
    },
    {
        path: '**',
        redirectTo: RouteEntity.Root,
        pathMatch: 'full',
    },
];
